import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import {
  showCustomToast,
  CustomToastContainer,
} from "../../components/CustomToast";
import "react-toastify/dist/ReactToastify.css";

const User_rationcard = () => {
  const { id } = useParams();
  const [licenseData, setLicenseData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [files, setFiles] = useState({});
  const [showDocument, setShowDocument] = useState(null);
  const statusEnum = ["In-Progress", "Submitted", "Rejected", "Completed"];

  useEffect(() => {
    const fetchLicenseData = async () => {
      try {
        const response = await axios.get(
          `https://api.makeeasydocuments.com/api/rationcard/getrationcard/${id}`
        );
        setLicenseData(response.data);
      } catch (err) {
        setError("Error fetching license data", 'error');
      } finally {
        setLoading(false);
      }
    };

    fetchLicenseData();
  }, [id]);

  const [documents, setDocuments] = useState({
    rationCard: null,
    aadharCard: null,
    photoIdentity: null,
    signature: null,
    talathiIncome: null,
  });
  
  const handleUpdate = async (event) => {
    event.preventDefault();
    
    
        // Update the status to "In-Progress"
        const updatedLicenseData = { ...licenseData, Status: "In-Progress" };
        const formData = new FormData();
    
        for (const key in updatedLicenseData) {
          if (updatedLicenseData.hasOwnProperty(key)) {
            // Skip the documents and user objects
            if (key !== 'documents' && key !== 'user') {
              // Handle dates specially
              if (updatedLicenseData[key] instanceof Date) {
                formData.append(key, updatedLicenseData[key].toISOString());
              }
              // Handle primitive values
              else if (typeof updatedLicenseData[key] !== 'object') {
                formData.append(key, updatedLicenseData[key]);
              }
            }
          }
        }
    
        // If you need to send the user ID, send it properly
        if (updatedLicenseData.user && updatedLicenseData.user._id) {
          formData.append('user', updatedLicenseData.user._id);
        }
    
        console.log("User Data:", licenseData.user);
        console.log("Updated Status:", updatedLicenseData.Status);
    
        // Append files to formData
        for (const [key, value] of Object.entries(files)) {
          if (value instanceof File) {
            formData.append(`documents.${key}`, value);
          }
        }
    
        // Log the FormData content for debugging
        for (let [key, value] of formData.entries()) {
          console.log(`${key}: ${value}`);
        }
    
    try {
      const response = await axios.put(
        `https://api.makeeasydocuments.com/api/rationcard/updaterationcard/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      showCustomToast(response.data.message);
      setTimeout(() => {
        window.location.href = "/dashboard/my_application"; // Redirect after 4 seconds
      }, 4001);
    } catch (error) {
      console.error("Update error:", error);
      showCustomToast("Failed to update license.", 'error');
     

    }
  };
  const renderImage = (imageData) => {
    try {
      // Check if all required properties exist and are valid
      if (
        imageData && 
        imageData.contentType && 
        imageData.data && 
        imageData.data.data && 
        Array.isArray(imageData.data.data)
      ) {
        const byteArray = new Uint8Array(imageData.data.data);
        const base64String = btoa(
          Array.from(byteArray)
            .map(byte => String.fromCharCode(byte))
            .join('')
        );
        return `data:${imageData.contentType};base64,${base64String}`;
      }
      console.log("Invalid image data:", imageData);
      return null;
    } catch (error) {
      console.error("Error rendering image:", error);
      return null;
    }
  };

  const DocumentPreviewModal = ({ document, onClose }) => {
    if (!document) return null;
  
    // Check if document is a string (URL) or an object
    const documentUrl = typeof document === 'string' ? document : null;
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-3xl w-full">
          <h2>Download The Documents From Here...</h2>
          
          {documentUrl && (
            <div className="my-4">
              <img 
                src={documentUrl} 
                className="max-w-full max-h-96 mx-auto"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = ""; // Placeholder for failed image load
                  // e.target.alt = "Unable to preview document";
                }}
              />
            </div>
          )}
  
          <div className="mt-4 flex justify-between">
            <button
              className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600"
              onClick={onClose}
            >
              Close
            </button>
            {documentUrl && (
              
                <a href={documentUrl}
                download
                className="bg-green-600 text-white py-2 px-4 rounded hover:bg-green-700"
              >
                Download
              </a>
            )}
          </div>
        </div>
      </div>
    );
  };
  const DownloadableDocuments = () => {
    if (!licenseData?.documents) return null;

    const { receipt, finisheddoc } = licenseData.documents;

    if (!receipt && !finisheddoc) return null;

    return (
      <div className="col-span-3 bg-white shadow-md p-6 rounded-lg mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          Downloadable Documents
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {receipt && (
            <div className="border p-4 rounded-lg text-center bg-gray-50">
              <h3 className="font-semibold mb-2">Receipt</h3>
              <button
                  className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
                  onClick={() => {
                    const imageUrl = renderImage(receipt);
                    setShowDocument(imageUrl);
                  }}
                >
                  View Receipt
                </button>
            </div>
          )}
          {finisheddoc && (
            <div className="border p-4 rounded-lg text-center bg-gray-50">
              <h3 className="font-semibold mb-2">Finished Document</h3>
              <button
                className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
                onClick={() => setShowDocument(renderImage(finisheddoc))}
              >
                View Document
              </button>
            </div>
          )}
        </div>
      </div>
    );
  };

  if (loading) return <div className="text-center mt-10">Loading...</div>;
  if (error)
    return <div className="text-center mt-10 text-red-500">{error}</div>;
  if (!licenseData) return <div>No data found</div>;

  const labelClass = "block text-sm mb-2 font-medium text-gray-700";
  const inputClass = "border border-gray-300 rounded-md p-2 w-full";

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="bg-white shadow-xl rounded-lg overflow-hidden">
          <div className="px-4 py-5 sm:p-6">
            <h1 className="text-3xl font-bold text-center text-gray-900 mb-8">
              Ration Card Certificate
            </h1>
            <DownloadableDocuments />
            <form onSubmit={handleUpdate} className="space-y-6">
              <div className="grid grid-cols-1 gap-6 sm:grid-cols-3">
                {/* Personal Information */}
                <div>
                  <label htmlFor="fullNameEnglish" className={labelClass}>
                    Full Name English
                  </label>
                  <input
                    type="text"
                    id="fullNameEnglish"
                    className={inputClass}
                    value={licenseData.fullNameEnglish || ""}
                    onChange={(e) =>
                      setLicenseData({
                        ...licenseData,
                        fullNameEnglish: e.target.value,
                      })
                    }
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>
                {/* Add other fields from the schema */}
                <div>
                  <label htmlFor="fullNameMarathi" className={labelClass}>
                    Full Name Marathi
                  </label>
                  <input
                    type="text"
                    id="fullNameMarathi"
                    className={inputClass}
                    value={licenseData.fullNameMarathi || ""}
                    onChange={(e) =>
                      setLicenseData({
                        ...licenseData,
                        fullNameMarathi: e.target.value,
                      })
                    }
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>
                {/* Continue with other fields as needed... */}
                {/* Add other fields from the schema */}
                <div>
                  <label htmlFor="application_type" className={labelClass}>
                    Application Type
                  </label>
                  <input
                    type="text"
                    id="application_type"
                    className={inputClass}
                    value={licenseData.application_type || ""}
                    onChange={(e) =>
                      setLicenseData({
                        ...licenseData,
                        application_type: e.target.value,
                      })
                    }
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="formPrice" className={labelClass}>
                    Form Price
                  </label>
                  <input
                    type="number"
                    id="formPrice"
                    className={inputClass}
                    value={licenseData.formPrice || ""}
                    onChange={(e) =>
                      setLicenseData({
                        ...licenseData,
                        formPrice: e.target.value,
                      })
                    }
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="fatherFullNameEnglish" className={labelClass}>
                    Father Full Name (English)
                  </label>
                  <input
                    type="text"
                    id="fatherFullNameEnglish"
                    className={inputClass}
                    value={licenseData.fatherFullNameEnglish || ""}
                    onChange={(e) =>
                      setLicenseData({
                        ...licenseData,
                        fatherFullNameEnglish: e.target.value,
                      })
                    }
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="fatherFullNameMarathi" className={labelClass}>
                    Father's Full Name (Marathi)
                  </label>
                  <input
                    type="text"
                    id="fatherFullNameMarathi"
                    className={inputClass}
                    value={licenseData.fatherFullNameMarathi || ""}
                    onChange={(e) =>
                      setLicenseData({
                        ...licenseData,
                        fatherFullNameMarathi: e.target.value,
                      })
                    }
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>
                <div>
                  <label htmlFor="incomeCertificate" className={labelClass}>
                    Income Certificate
                  </label>
                  <input
                    type="text"
                    id="incomeCertificate"
                    className={inputClass}
                    value={licenseData.incomeCertificate || ""}
                    onChange={(e) =>
                      setLicenseData({
                        ...licenseData,
                        incomeCertificate: e.target.value,
                      })
                    }
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="dateOfBirth" className={labelClass}>
                    Date of Birth
                  </label>
                  <input
                    type="date"
                    id="dateOfBirth"
                    className={inputClass}
                    value={licenseData.dateOfBirth || ""}
                    onChange={(e) =>
                      setLicenseData({
                        ...licenseData,
                        dateOfBirth: e.target.value,
                      })
                    }
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="age" className={labelClass}>
                    Age
                  </label>
                  <input
                    type="text"
                    id="age"
                    className={inputClass}
                    value={licenseData.age || ""}
                    onChange={(e) =>
                      setLicenseData({ ...licenseData, age: e.target.value })
                    }
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="gender" className={labelClass}>
                    Gender
                  </label>
                  <select
                    id="gender"
                    className={inputClass}
                    value={licenseData.gender || ""}
                    onChange={(e) =>
                      setLicenseData({ ...licenseData, gender: e.target.value })
                    }
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="mobileNumber" className={labelClass}>
                    Mobile Number
                  </label>
                  <input
                    type="text"
                    id="mobileNumber"
                    className={inputClass}
                    value={licenseData.mobileNumber || ""}
                    onChange={(e) =>
                      setLicenseData({
                        ...licenseData,
                        mobileNumber: e.target.value,
                      })
                    }
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="service" className={labelClass}>
                    Service
                  </label>
                  <input
                    type="text"
                    id="service"
                    className={inputClass}
                    value={licenseData.service || ""}
                    onChange={(e) =>
                      setLicenseData({
                        ...licenseData,
                        service: e.target.value,
                      })
                    }
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="address" className={labelClass}>
                    Address
                  </label>
                  <input
                    type="text"
                    id="address"
                    className={inputClass}
                    value={licenseData.address || ""}
                    onChange={(e) =>
                      setLicenseData({
                        ...licenseData,
                        address: e.target.value,
                      })
                    }
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>
                <div>
                  <label htmlFor="state" className={labelClass}>
                    State
                  </label>
                  <input
                    type="text"
                    id="state"
                    className={inputClass}
                    value={licenseData.state || ""}
                    onChange={(e) =>
                      setLicenseData({
                        ...licenseData,
                        state: e.target.value,
                      })
                    }
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="district" className={labelClass}>
                    District
                  </label>
                  <input
                    type="text"
                    id="district"
                    className={inputClass}
                    value={licenseData.district || ""}
                    onChange={(e) =>
                      setLicenseData({
                        ...licenseData,
                        district: e.target.value,
                      })
                    }
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="pincode" className={labelClass}>
                    pincode
                  </label>
                  <input
                    type="text"
                    id="pincode"
                    className={inputClass}
                    value={licenseData.pincode || ""}
                    onChange={(e) =>
                      setLicenseData({ ...licenseData, pincode: e.target.value })
                    }
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                <div>
                  <label htmlFor="sourceOfIncome" className={labelClass}>
                    Source Of Income
                  </label>
                  <input
                    type="text"
                    id="sourceOfIncome"
                    className={inputClass}
                    value={licenseData.sourceOfIncome || ""}
                    onChange={(e) =>
                      setLicenseData({
                        ...licenseData,
                        sourceOfIncome: e.target.value,
                      })
                    }
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>

                {/* Beneficiary Information */}
                <div>
                  <label htmlFor="purposeOfIncomeCertificate" className={labelClass}>
                    purpose Of Income Certificate
                  </label>
                  <input
                    type="text"
                    id="purposeOfIncomeCertificate"
                    className={inputClass}
                    value={licenseData.purposeOfIncomeCertificate || ""}
                    onChange={(e) =>
                      setLicenseData({
                        ...licenseData,
                        purposeOfIncomeCertificate: e.target.value,
                      })
                    }
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>


                {/* File Uploads */}
                <div className="col-span-3">
                  <h2 className="text-xl font-semibold text-gray-900 mb-4">
                    Documents
                  </h2>
                  <div className="grid grid-cols-1 gap-6 sm:grid-cols-3">
                    {[
                      "rationCard",
                      "aadharCard",
                      "photoIdentity",
                      "signature",
                      "talathiIncome",
                    ].map((doc) => (
                      <div key={doc}>
                        <label htmlFor={doc} className={labelClass}>
                          {doc
                            .replace(/([A-Z])/g, " $1")
                            .charAt(0)
                            .toUpperCase() +
                            doc
                              .replace(/([A-Z])/g, " $1")
                              .slice(1)
                              .toLowerCase()}
                        </label>
                        <input
                          type="file"
                          id={doc}
                          className={inputClass}
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file && file.size > 2 * 1024 * 1024) {
                              alert(
                                "File size exceeds 2MB. Please upload a smaller file."
                              );
                            } else {
                              setFiles({ ...files, [doc]: file });
                            }
                          }}
                          accept=".jpg,.jpeg,.png,.pdf"
                        />
                      </div>
                    ))}
                  </div>
                </div>

                {/* Application History */}
                <div className="col-span-3 bg-green-50 shadow-md p-6 rounded-lg w-full space-y-4">
                  <h2 className="text-xl text-center font-bold mb-4 text-gray-700 border-b-2 border-gray-400 pb-2">
                    Application History
                  </h2>

                  <div className="flex justify-between text-gray-800">
                    <strong className="text-gray-600 flex-1">
                      Created At (Date & Time):
                    </strong>
                    <span className="flex-1 text-center text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                      {new Date(licenseData.createdAt).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: true,
                      })}
                    </span>
                  </div>

                  <div className="flex justify-between text-gray-800">
                    <strong className="text-gray-600 flex-1">
                      Updated At (Date & Time):
                    </strong>
                    <span className="flex-1 text-center text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                      {licenseData.updatedAt
                        ? new Date(licenseData.updatedAt).toLocaleString(
                          "en-IN",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true,
                          }
                        )
                        : "N/A"}
                    </span>
                  </div>

                  <div>
                    <label htmlFor="Status" className={labelClass}>
                      Status
                    </label>
                    <input
                      disabled
                      type="text"
                      id="Status"
                      className={`${inputClass} bg-gray-200`}
                      value={licenseData.Status || ""}
                      required
                    />
                  </div>

               {/* history */}
                {/* Display history regardless of Status */}
                <div className="flex justify-between text-gray-800">
                  <div className="text-gray-600 flex-1">
                    <strong className="text-gray-600">Status History:</strong>
                  </div>

                  {/* Display for new schema with statusHistory */}
                  {licenseData.statusHistory && licenseData.statusHistory.length > 0 ? (
                    <div className="flex-1 text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                      {licenseData.statusHistory.map((statusChange, index) => (
                        <div
                          key={index}
                          className={`p-3 ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} border-b border-gray-300 last:border-b-0`}
                        >
                          <div className="flex justify-between items-center mb-1">
                            <span className="text-sm font-medium text-gray-500">
                              Changed on: {new Date(statusChange.changedAt).toLocaleString()}
                            </span>
                            <span className={`text-xs font-semibold px-2 py-1 rounded ${statusChange.status === 'Rejected' ? 'bg-red-100 text-red-800' :
                                statusChange.status === 'Submitted' ? 'bg-blue-100 text-blue-800' :
                                  statusChange.status === 'Completed' ? 'bg-green-100 text-green-800' :
                                    'bg-yellow-100 text-yellow-800'
                              }`}>
                              {statusChange.status}
                            </span>
                          </div>
                          <p className="text-gray-700">{statusChange.note || "No additional notes"}</p>
                        </div>
                      ))}
                    </div>
                  ) : (
                    // Fallback for when no status history exists
                    <div className="text-center text-gray-500 border border-gray-300 bg-gray-50 p-3 rounded">
                      No status history available
                    </div>
                  )}
                </div>            
            </div>

                

{licenseData.Status === "Rejected" && (
                <div>
                  <button
                    type="submit"
                    className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
                  >
                    Update Application
                  </button>
                </div>
              )}

              </div>
            </form>
            <DocumentPreviewModal
              document={showDocument}
              onClose={() => setShowDocument(null)}
            />

            <CustomToastContainer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default User_rationcard
